import React from 'react'
import "./Members.css"
import MemberCard from '../../components/member_card/Member_Card';
import { getActiveMembers, getInActiveMembers} from '../../util/Member_Query';

function Members () {

    var activeMembers = getActiveMembers();
    var inactiveMembers = getInActiveMembers();


    
    return (
        <div className='Members-Parent'>
            
            <div className="Members-Introduction-Container">
                <h1 className="Title">Members</h1>
                <p className="Members-Introduction">
                     The Mindpunch community has been around for a long time, over 10 Years in fact. And durring that time we have had many members come and go. Whilst we might not have every member documented correctly due to information being lost to time, we have tried our best to source all prior members and add them to the list.                     
                </p>
            </div>

            <div className="Active-Members-Contatiner">
                <h2 className='SubTitle'>Active Members</h2>
                <div className='Members-Container'>
                      
                        { activeMembers.map((member) => (
                            
                            <MemberCard member={member} />
                            
                        ))
                            

                        }
                    
                </div>
            </div>

            <div className='Inactive-Members-Container'>
                <h2 className='SubTitle'>Inactive Members</h2>
                <div className='Members-Container'>
                      
                      { 
                        inactiveMembers.map((member) => (
                          <MemberCard member={member}/>
                      ))
                      }
                  
                </div>
            </div>

            
        </div>
    )
}

export default Members;